import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface ScrollRevealProps {
  children: ReactNode;
  width?: 'fit-content' | '100%';
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  className?: string;
}
export function ScrollReveal({
  children,
  width = 'fit-content',
  delay = 0,
  direction = 'up',
  className = ''
}: ScrollRevealProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0.2
  });
  const getDirectionOffset = () => {
    switch (direction) {
      case 'up':
        return {
          y: 20,
          x: 0
        };
      case 'down':
        return {
          y: -20,
          x: 0
        };
      case 'left':
        return {
          x: 20,
          y: 0
        };
      case 'right':
        return {
          x: -20,
          y: 0
        };
      default:
        return {
          y: 20,
          x: 0
        };
    }
  };
  const {
    x,
    y
  } = getDirectionOffset();
  return <div ref={ref} style={{
    width
  }} className={className} data-id="element-121">
      <motion.div initial={{
      opacity: 0,
      x,
      y
    }} animate={isInView ? {
      opacity: 1,
      x: 0,
      y: 0
    } : {
      opacity: 0,
      x,
      y
    }} transition={{
      duration: 1.2,
      delay,
      ease: [0.25, 0.1, 0.25, 1.0] // Cubic bezier for smooth, organic feel
    }} data-id="element-122">
        {children}
      </motion.div>
    </div>;
}